<mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="template-tree" style="background-color: transparent;">
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
        <li class="mat-tree-node" (click)="nodeSelected(node)">
            <button mat-icon-button disabled></button>
            <span id="x{{node.id}}">{{node.displayText}}</span>
        </li>
    </mat-tree-node>
    <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
        <li>
            <div class="mat-tree-node" (click)="nodeSelected(node)">
                <button mat-icon-button matTreeNodeToggle
                        [attr.aria-label]="'toggle ' + node.name">
                    <mat-icon class="mat-icon-rtl-mirror">
                        {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                    </mat-icon>
                </button>
                <span id="x{{node.id}}">{{node.displayText}}</span>
            </div>
            <ul [class.template-tree-invisible]="!treeControl.isExpanded(node)">
                <ng-container matTreeNodeOutlet></ng-container>
            </ul>
        </li>
    </mat-nested-tree-node>
</mat-tree>
